import React, { useEffect, useRef, useState } from "react";
import "./MarqueeSlider.css";
import { baseUrl } from "../../baseUrl";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const MarqueeSlider = () => {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const trackRef = useRef(null);
  const containerRef = useRef(null);

  const fetchCourses = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${baseUrl}/course/all`);
      setCourses(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  useEffect(() => {
    if (trackRef.current && containerRef.current) {
      const trackWidth = trackRef.current.scrollWidth;
      const containerWidth = containerRef.current.offsetWidth;
      const totalDistance = trackWidth + containerWidth;
      const speed = 100; // px/sec
      const duration = totalDistance / speed;

      // Set dynamic CSS variables
      trackRef.current.style.setProperty('--marquee-duration', `${duration}s`);
      trackRef.current.style.setProperty('--start-position', `${containerWidth}px`);
      trackRef.current.style.setProperty('--end-position', `-${trackWidth}px`);
    }
  }, [courses]);

  return (
    <>
      {!loading && courses.length > 0 && (
        <div className="marquee-container" ref={containerRef}>
          <div className="marquee-track" ref={trackRef}>
            <div className="marquee-item1">Courses :</div>
            {courses.map((item, index) => (
              <div
                className="marquee-item"
                key={index}
                onClick={() => navigate(`/course/${item.courseID}`)}
              >
                {item.className} - {item.title}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default MarqueeSlider;